<template>
  <div class="ol-map-container" ref="olMap">
    <slot v-if="mapReady"> </slot>
  </div>
</template>

<script>
import "ol/ol.css";
import OlMap from "ol/Map.js";
import View from "ol/View.js";
import { getCenter } from "ol/extent.js";
import ImageLayer from "ol/layer/Image.js";
import Projection from "ol/proj/Projection.js";
import Static from "ol/source/ImageStatic.js";
export default {
  name: "OlMap",
  props: {
    mapSrc: {
      //地图图片
      type: String,
      default() {
        return null;
      },
    },
    /**
     * 地图的分辨率。这个参数表示地图中一个像素对应的实际长度（以米为单位）。在子中，分辨率为0.05米/像素，意味着每个像素代表地图中0.05米的实际长度。
     */
    resolution: {
      type: Number,
      default: 0.05,
    },
    /**地图的原点坐标。这是一个包含三个值的数组，表示地图坐标系的原点在世界坐标系中置。在这个例子中，原点坐标为(-18.6, -17.0, 0.0)，表示地图坐标系的原点位于世界坐标系中的(-1
     *-17.0)位置，并且Z轴的高度为0.0。
     */
    origin: {
      type: Array,
      default: () => [0, 0, 0],
    },
  },
  data() {
    return {
      mapReady: false,
    };
  },
  methods: {
    initMap() {
      this.$map = new OlMap({
        layers: [],
        target: this.$refs.olMap,
        controls: [],
      });
      this.$map.on("singleclick", (evt) => {
        console.log("坐标:", evt.coordinate);
      });
    },
    addLayer() {
      const self = this;
      if (this.$imageLayer) {
        this.$map.removeLayer(this.$imageLayer);
      }
      if (this.$view) {
        this.$map.setView(null);
      }
      if (this.mapSrc) {
        self.mapReady = false;
        const mapImg = new Image();
        mapImg.src = this.mapSrc;
        mapImg.onload = () => {
          let imgW = mapImg.width;
          let imgH = mapImg.height;
          const extent = [0, 0, imgW, imgH];
          const projection = new Projection({
            code: "robot-map-image",
            units: "pixels",
            extent: extent,
          });

          let imgLayer = new ImageLayer({
            source: new Static({
              url: self.mapSrc,
              projection: projection,
              imageExtent: extent,
            }),
          });
          let view = new View({
            projection: projection,
            center: getCenter(extent),
            zoom: 0,
            maxZoom: 8,
          });
          self.$map.addLayer(imgLayer);
          self.$map.setView(view);
          self.$imageLayer = imgLayer;
          self.$view = view;
          self.mapReady = true;
        };
      }
    },

    /**
     * 世界坐标转地图坐标
     * @param {*} wx
     * @param {*} wy
     * @returns
     */
    worldToRosMap(wx, wy) {
      let originX = this.origin[0];
      let originY = this.origin[1];
      if (wx < originX || wy < originY) return [originX, originY];
      let mapX = (wx - originX) / this.resolution;
      let mapY = (wy - originY) / this.resolution;
      // console.log(wx, wy);
      // console.log(mapX, mapY);
      return [mapX, mapY];
    },
  },

  mounted() {
    this.initMap();
    if (this.mapSrc) {
      this.addLayer();
    }
  },
  watch: {
    mapSrc(val) {
      if (val) {
        this.addLayer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ol-map-container {
  height: 100%;
  width: 100%;
}
</style>>